module.exports = __webpack_public_path__ + "static/media/nopic.158b766a.svg";